/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PublicTransportInformationType {
    FAHRPLANAUSHANG = 'FAHRPLANAUSHANG',
    ZUGANG_INTRANET_FAHRPLAN = 'ZUGANG_INTRANET_FAHRPLAN',
    OTHER = 'OTHER',
}
